export const TECH_STACKS = [
  { name: 'Front-End', value: 'FE' },
  { name: 'Back-End', value: 'BE' },
  { name: 'QA', value: 'QA' }
]
